import http from '../../../Utils/http';
const AuditLogs = {
    name: 'AuditLogs',
    state: {
        loading: false,
        error: '',
        data: [],
        totalEntries: 0,
    },
    reducers: {
        AuditLogsRequested(state) {
            return {
                ...state,
                loading: true,
                error: '',
                data: [],
                totalEntries: 0,
            };
        },
        AuditLogsReceived(state, payload) {
            // payload may contain rows under payload.data.rows or be an array itself
            const rows = Array.isArray(payload?.data?.rows)
                ? payload.data.rows
                : Array.isArray(payload?.data)
                ? payload.data
                : Array.isArray(payload)
                ? payload
                : [];

            const data = rows.map((item) => ({
                id: item?.id || item?.log_id || null,
                action: item?.action || item?.type || 'N/A',
                performed_by: item?.user?.name || item?.performed_by || 'N/A',
                timestamp: item?.action_performed_at || item?.created_at || item?.timestamp || null,
                resource: item?.resource_type || item?.resource || 'N/A',
                resource_name: item?.resource?.name || item?.resource_name || 'N/A',
                details: item?.extra_info || 'N/A',
            }));

            return {
                ...state,
                loading: false,
                data,
                error: '',
                totalEntries: payload?.data?.totalCount
            };
        },
        AuditLogsRequestFailed(state, payload) {
            return {
                ...state,
                error: payload,
                data: [],
                loading: false,
                totalEntries: 0,
            };
        },

    },
    effects: (dispatch) => ({
        async requestForAuditLogs({ sorted_by, sort, page, rpp }) {
            try {
                this.AuditLogsRequested();
                const params = new URLSearchParams();
                if (sorted_by) params.append('sorted_by', sorted_by);
                if (sort) params.append('sort', sort);
                params.append('page', String(page));
                params.append('rpp', String(rpp));

                const response = await http.get(`savvy/audit-logs?${params.toString()}`);
                this.AuditLogsReceived(response.data);
            } catch (err) {
                const message = err?.response?.data?.error || err?.message || 'Unknown error';
                this.AuditLogsRequestFailed(message);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        data: 'Audit Logs fetch failed',
                        open: true,
                    },
                });
            }
        },

        async requestForAuditLogsByOrg({ sorted_by, sort, page, rpp, org_id }) {
            try {
                this.AuditLogsRequested();
                const params = new URLSearchParams();
                if (sorted_by) params.append('sorted_by', sorted_by);
                if (sort) params.append('sort', sort);
                if (org_id) params.append('org_id', String(org_id));
                params.append('page', String(page));
                params.append('rpp', String(rpp));

                const response = await http.get(`savvy/audit-logs/org?${params.toString()}`);
                this.AuditLogsReceived(response.data);
            } catch (err) {
                const message = err?.response?.data?.error || err?.message || 'Unknown error';
                this.AuditLogsRequestFailed(message);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        data: 'Audit Logs fetch failed',
                        open: true,
                    },
                });
            }
        },
    }),
};

export default AuditLogs;